export default __webpack_public_path__ + "static/media/ic_turkmenistan.ca8a95d7.svg";